import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import CustomSelectField from '@/components/inputs/CustomSelectField'
import type { ActivationGroupOption } from '@/features/bidding/types/activationGroup'

type Props = {
  selectedActivationGroup: ActivationGroupOption
  activationGroups: ActivationGroupOption[]
  setSelectedActivationGroup: (newActivationGroup: ActivationGroupOption) => void
}

const ActivationGroupSelector: FC<Props> = ({
  selectedActivationGroup,
  activationGroups,
  setSelectedActivationGroup,
}) => {
  const { t } = useTranslation()

  const handleActivationGroupChange = (newActivationGroupUuid: string | undefined) => {
    if (!newActivationGroupUuid) return

    const newActivationGroup = activationGroups.find((ag) => ag.uuid === newActivationGroupUuid)

    if (newActivationGroup) {
      setSelectedActivationGroup(newActivationGroup)
    }
  }

  return (
    <CustomSelectField
      data-testid="activation-group-selector"
      id="activation-group-selector"
      label={t('bidding.results.activation_group')}
      options={activationGroups.map((group) => ({
        id: String(group.uuid),
        value: group.uuid,
        label: group.code,
      }))}
      size="medium"
      sx={{ minWidth: 160 }}
      value={selectedActivationGroup.uuid}
      onChange={(event) => handleActivationGroupChange(event.target.value)}
    />
  )
}

export default ActivationGroupSelector
